import PropTypes from 'prop-types';
import React, { Children, Component } from 'react';
import { TransitionMotion, presets, spring } from 'react-motion';
import { withDefaultComponentProps } from '../../../decorators/withDefaultComponentProps';
const COMPONENT_NAME = 'SlideIn';
class SlideIn extends Component {
    static displayName = 'SlideIn';
    willLeave = ()=>({
            opacity: spring(0, presets.gentle),
            scaleY: spring(0, presets.gentle)
        });
    willEnter = ()=>({
            opacity: 0,
            scaleY: 0
        });
    prepareStyles() {
        const children = this.props.children;
        const styles = [];
        Children.forEach(children, (currentChild)=>{
            styles.push({
                key: currentChild.key,
                data: {
                    child: currentChild
                }
            });
        });
        return styles;
    }
    getStyles() {
        return this.prepareStyles().map((config)=>Object.assign({}, config, {
                style: {
                    opacity: spring(1, presets.gentle),
                    scaleY: spring(1, presets.gentle)
                }
            }));
    }
    getDefaultStyles() {
        return this.prepareStyles().map((config)=>Object.assign({}, config, {
                style: {
                    opacity: 0,
                    scaleY: 0
                }
            }));
    }
    render() {
        const style = this.props.style;
        return /*#__PURE__*/ React.createElement(TransitionMotion, {
            styles: this.getStyles(),
            defaultStyles: this.getDefaultStyles(),
            willLeave: this.willLeave,
            willEnter: this.willEnter
        }, (interpolatedStyles)=>/*#__PURE__*/ React.createElement("div", null, interpolatedStyles.map((config)=>{
                const child = config.data.child;
                return /*#__PURE__*/ React.cloneElement(config.data.child, {
                    style: {
                        transformOrigin: 'left top',
                        ...style,
                        ...child.props.style,
                        opacity: config.style.opacity,
                        WebkitTransform: `scaleY(${config.style.scaleY}) translateZ(0)`,
                        msTransform: `scaleY(${config.style.scaleY}) translateZ(0)`,
                        transform: `scaleY(${config.style.scaleY}) translateZ(0)`
                    },
                    key: config.key
                });
            })));
    }
}
SlideIn.propTypes = {
    /**
	 * Elements to animate. Must be keyed by 'key' property.
	 */ children: PropTypes.node,
    /**
	 * Additional styles to apply to children.
	 */ style: PropTypes.object
};
export { SlideIn };
export default withDefaultComponentProps(COMPONENT_NAME, {}, SlideIn);
